// @ts-nocheck
import React from 'react';
import { connect } from 'react-redux';
import { initialize } from 'redux-form';
import { Entity } from '@sketchpixy/rubix/lib/L20n';
import _ from 'lodash';
import moment from 'moment';
import { POWER_CONTROL_UNIT_EVENT_TYPE, POWER_CONTROL_UNIT_EVENT_TYPE_L20N } from '../_config/consts';
import * as PowerControlUnitsActions from '../redux/actions/powerControlUnits.actions';
import PresentationalViewHeader from '../components/PresentationalView/PresentationalViewHeader.jsx';
import PowerControlUnitEventsView from '../components/PowerControlUnits/PowerControlUnitEventsView.jsx';
import EmptyView from '../components/EmptyView.jsx';
import TranslatableOption from '../components/forms/Fields/TranslatableOption.jsx';

@connect(state => ({
  powerControlUnits: state.powerControlUnits,
  themeName: state.settings.items.theme.data.themeName,
}))
class EnergyManagementHistory extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      searchText: '',
      selectedPCUId: null,
    };
  }

  async componentDidMount() {
    await this.onFetchAllPCUs();
  }

  syncSearchBarForm(pcuId, eventType, searchText = '') {
    const { dispatch } = this.props;
    const formValues = {
      type: searchText || '',
      eventType: eventType || '',
    };
    if (pcuId !== undefined && pcuId !== null) {
      formValues.powerControlUnit = String(pcuId);
    }
    dispatch(initialize('SearchBarForm', formValues));
  }

  async onFetchAllPCUs() {
    const { dispatch, powerControlUnits } = this.props;
    const { eventType } = powerControlUnits.events.filters;
    try {
      const pcus = await dispatch(PowerControlUnitsActions.fetchPowerControlUnits(0, false, 1000));
      if (pcus && pcus.length > 0) {
        const firstPcuId = pcus[0].id;
        this.setState({ selectedPCUId: firstPcuId });
        this.syncSearchBarForm(firstPcuId, eventType);
      }
    } catch (error) {
      console.error('Error fetching PCUs:', error);
    }
  }

  refetchEvents() {
    const { dispatch } = this.props;
    const { selectedPCUId } = this.state;
    if (selectedPCUId) {
      dispatch(PowerControlUnitsActions.resetPowerControlUnitEventsPaginationData());
      dispatch(PowerControlUnitsActions.fetchPowerControlUnitEvents(selectedPCUId, 0));
    }
  }

  onRefresh() {
    this.refetchEvents();
  }

  onSearchTextChange(searchText) {
    this.setState({ searchText });
  }

  onSearchSubmit(formData) {
    const { dispatch } = this.props;
    const searchText = formData && formData.type ? formData.type : '';
    let selectedPCUId = this.state.selectedPCUId;
    if (formData && formData.powerControlUnit) {
      const pcuId = parseInt(formData.powerControlUnit, 10);
      if (!Number.isNaN(pcuId)) {
        selectedPCUId = pcuId;
      }
    }
    const eventType = formData && formData.eventType ? formData.eventType : null;
    dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('eventType', eventType || null));
    this.setState({ searchText, selectedPCUId }, () => {
      this.refetchEvents();
    });
  }

  onSearchReset() {
    const { dispatch, powerControlUnits } = this.props;
    const pcus = powerControlUnits.data.content || [];
    const defaultFromDate = moment().startOf('month').valueOf();
    const defaultToDate = moment().endOf('month').valueOf();
    const firstPcuId = pcus.length > 0 ? pcus[0].id : null;

    dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('fromDate', defaultFromDate));
    dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('toDate', defaultToDate));
    dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('eventType', null));

    this.setState({ searchText: '', selectedPCUId: firstPcuId });
    this.syncSearchBarForm(firstPcuId, null, '');

    if (firstPcuId) {
      dispatch(PowerControlUnitsActions.resetPowerControlUnitEventsPaginationData());
      dispatch(PowerControlUnitsActions.fetchPowerControlUnitEvents(firstPcuId, 0));
    }
  }

  onSelectPCU(value) {
    const pcuId = parseInt(value, 10);
    if (Number.isNaN(pcuId)) {
      return;
    }
    const { powerControlUnits } = this.props;
    const { eventType } = powerControlUnits.events.filters;
    this.setState({ selectedPCUId: pcuId });
    this.syncSearchBarForm(pcuId, eventType);
  }

  onDatesChange(startDate, endDate) {
    const { dispatch } = this.props;
    if (startDate) {
      dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter(
        'fromDate',
        moment(startDate).startOf('day').valueOf(),
      ));
    } else {
      dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('fromDate', null));
    }
    if (endDate) {
      dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter(
        'toDate',
        moment(endDate).endOf('day').valueOf(),
      ));
    } else {
      dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('toDate', null));
    }
  }

  onSelectEventType(value) {
    const { dispatch, powerControlUnits } = this.props;
    const { selectedPCUId } = this.state;
    const eventType = value || null;
    dispatch(PowerControlUnitsActions.setPowerControlUnitEventsFilter('eventType', eventType));
    this.syncSearchBarForm(selectedPCUId, eventType);
  }

  render() {
    const { themeName, powerControlUnits } = this.props;
    const { searchText, selectedPCUId } = this.state;
    const { fromDate, toDate } = powerControlUnits.events.filters;

    const pcus = powerControlUnits.data.content || [];
    const pcuSelectableOptions = _.map(pcus, pcu => (
      <option value={pcu.id} key={pcu.id}>
        {pcu.name || pcu.id}
      </option>
    ));

    const eventTypeSelectableOptions = [
      (
        <Entity
          key="allEvents"
          componentClass={TranslatableOption}
          value=""
          componentAttribute="text"
          entity="allEvents"
        />
      ),
      ..._.map(POWER_CONTROL_UNIT_EVENT_TYPE, typeValue => (
        <Entity
          key={typeValue}
          componentClass={TranslatableOption}
          value={typeValue}
          componentAttribute="text"
          entity={POWER_CONTROL_UNIT_EVENT_TYPE_L20N[typeValue]}
        />
      )),
    ];

    return (
      <div className="smartlocks-events-container" style={{ marginTop: -10, backgroundColor: 'white' }}>
        <PresentationalViewHeader
          themeName={themeName}
          containerStyle={{ height: 110 }}
          title={<Entity entity="energyManagementHistory" />}
          searchPlaceholderEntityName="search"
          onFilterChange={(text) => this.onSearchTextChange(text)}
          onSearchSubmit={(formData) => this.onSearchSubmit(formData)}
          onSearchReset={() => this.onSearchReset()}
          onRefresh={() => this.onRefresh()}
          selectableFieldName="powerControlUnit"
          selectableOptions={pcuSelectableOptions}
          onSelectOption={(value) => this.onSelectPCU(value)}
          selectableFieldName2="eventType"
          selectableOptions2={eventTypeSelectableOptions}
          onSelectOption2={(value) => this.onSelectEventType(value)}
          onDatesChange={(startDate, endDate) => this.onDatesChange(startDate, endDate)}
          startDate={fromDate ? moment(fromDate) : moment().startOf('month')}
          endDate={toDate ? moment(toDate) : moment().endOf('month')}
        />
        <div className="smartlocks-events-list-container" style={{ paddingLeft: 20, marginTop: 0, backgroundColor: 'white' }}>
          {pcus.length === 0 ? (
            <EmptyView entityName="powerControlUnits" title="noPowerControlUnitsTitle" subtitle="noPowerControlUnitsSubtitle" />
          ) : selectedPCUId ? (
            <div style={{ marginTop: 150 }}>
              <PowerControlUnitEventsView
                key={selectedPCUId}
                powerControlUnitId={selectedPCUId}
                searchText={searchText}
                autoFetchOnFilterChange={false}
                listStyle={{ paddingBottom: 320 }}
              />
            </div>
          ) : (
            <EmptyView entityName="events" title="noPowerControlUnitsEventsTitle" subtitle="noPowerControlUnitsEventsSubtitle" />
          )}
        </div>
      </div>
    );
  }
}

export default EnergyManagementHistory;
